// Utilidades de fecha del módulo No-Clientes (fuente única).
// El backend serializa las fechas en UTC. Los DateTime de datetime2 salían SIN sufijo 'Z' -> el
// navegador los tomaba como hora local y el día se corría (bug histórico). El backend ya emite 'Z'
// para estos DTOs, pero igual detectamos si falta la zona y forzamos UTC para ser robustos ante
// cualquier valor. Siempre mostramos en hora de Chile (America/Santiago), igual que HubSpot.

const toUtcDate = (value) => {
  const hasTz = /[zZ]$|[+-]\d{2}:?\d{2}$/.test(value);
  return new Date(hasTz ? value : `${value}Z`);
};

export const formatChileDateTime = (value, fallback = '') => {
  if (!value) return fallback;
  const d = toUtcDate(value);
  if (Number.isNaN(d.getTime())) return fallback;
  return d.toLocaleString('es-CL', {
    timeZone: 'America/Santiago',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

// Solo fecha (sin hora), en hora de Chile.
export const formatChileDate = (value, fallback = '') => {
  if (!value) return fallback;
  const d = toUtcDate(value);
  if (Number.isNaN(d.getTime())) return fallback;
  return d.toLocaleDateString('es-CL', {
    timeZone: 'America/Santiago',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};

// Igual que formatChileDateTime pero desde un instante en ms (para fechas ya normalizadas).
export const formatChileMs = (ms) => {
  if (!ms) return '';
  const d = new Date(ms);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString('es-CL', {
    timeZone: 'America/Santiago',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

// Instante (ms UTC) de un valor de fecha (con o sin 'Z'), para comparar el último contacto por canal.
export const toUtcMs = (value) => {
  if (!value) return 0;
  const d = toUtcDate(value);
  return Number.isNaN(d.getTime()) ? 0 : d.getTime();
};
